import { localStorageHelper } from '../../helpers/storage/index.js';
import { isLoggedIn } from '../../services/schibstedAccount.js';
import { getDaysDiff } from '../../utils/datetime.js';

const LOCAL_STORAGE_KEY = 'continue-as-popup-last-shown-on';

/**
 * Stores the given timestamp as the time when the popup has been shown most recently.
 */
function setLastShown(lastShown: number) {
  localStorageHelper.setItem(LOCAL_STORAGE_KEY, lastShown);
}

/**
 * Returns a timestamp for when the popup has been shown most recently.
 */
function getLastShown() {
  const lastShown = localStorageHelper.getItem(LOCAL_STORAGE_KEY);

  return lastShown !== null ? parseInt(lastShown, 10) : null;
}

/**
 * Checks whether the "Continue as" popup should be shown for the current user.
 * It will only be shown to a user who is not logged in, and hasn't seen the popup
 * for at least 7 days.
 *
 * NOTE: we don't need to check whether we have user data available from a different
 * site - that is already handled by the Schibsted Account SDK.
 *
 * @returns {Promise<boolean>}
 */
async function shouldShowPopup() {
  const loggedIn = await isLoggedIn();
  const lastShown = getLastShown();

  return (
    !loggedIn && (lastShown === null || getDaysDiff(lastShown, Date.now()) > 7)
  );
}

export { shouldShowPopup, getLastShown, setLastShown };
